import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { LocalStorageService } from 'angular-2-local-storage';
import { GlobalVariable } from './../shared/global';
@Injectable()
export class ProfileService {
	// private variables of django rest api urls
	// private baseApiUrl = GlobalVariable.BASE_API_URL;
	private baseApiUrlTest = GlobalVariable.BASE_API_URL;
	private headers = new Headers({ 'Content-Type': 'application/json' });
	// private account_settings_url = this.baseApiUrl + 'api/rest/v1/update/account/';
	private account_settings_url = this.baseApiUrlTest + 'api/account/update/account';
	private update_notification_channel_url = this.baseApiUrlTest + 'api/account/update/notificationChannel';
	private change_address_url = this.baseApiUrlTest + 'api/account/update/account/';
	// private update_email = this.baseApiUrl + 'api/rest/v1/auth/reset_email/';
	private update_email = this.baseApiUrlTest + 'api/account/change/email';
	private update_mobile = this.baseApiUrlTest + 'api/account/change/mobile';
	// private verify_email = this.baseApiUrlTest + 'api/rest/v1/auth/done/reset_email/';
	private verify_email = this.baseApiUrlTest + 'api/auth/done/reset_email/';
	// private account_detail = this.baseApiUrl + 'api/rest/v1/agent/search/';
	private account_detail = this.baseApiUrlTest + 'api/admin/searchValid';
	// private refresh_account = this.baseApiUrl + 'api/rest/v1/agent/search/';
	private refresh_account = this.baseApiUrlTest + 'api/admin/searchValid';
	// private reset_password = this.baseApiUrl + 'api/rest/v1/auth/reset_password/';
	private reset_password = this.baseApiUrlTest + 'api/auth/forget/password';

	constructor(private http: Http, private localStorageService: LocalStorageService) { }
	// update account setting
	updateAccountSettings(account_settings: Object) {
		return this.http
			.put(this.account_settings_url, account_settings)
			.toPromise()
			.then(res => res.json())
			.catch(this.handleError);
	}

	updateNotificationChannel(notification_channel_setting: Object) {
		return this.http
			.post(this.update_notification_channel_url, notification_channel_setting)
			.toPromise()
			.then(res => res.json())
			.catch(this.handleError);
	}

	refreshAccountByAgent(account_settings: Object) {
		return this.http
			.post(this.refresh_account, account_settings)
			.toPromise()
			.then(res => res.json())
			.catch(this.handleError);
	}
	// address change
	changeAddress(address: Object) {
		return this.http
			.post(this.change_address_url, address)
			.toPromise()
			.then(res => res.json())
			.catch(this.handleError);
	}

	updateEmail(data: Object) {
		return this.http
			.put(this.update_email, data)
			.toPromise()
			.then(res => res.json())
			.catch(this.handleError);
	}

	updateMobile(data: Object) {
		return this.http
			.put(this.update_mobile, data)
			.toPromise()
			.then(res => res.json())
			.catch(this.handleError);
	}

	verifyEmail(data: Object) {
		return this.http
			.post(this.verify_email, data)
			.toPromise()
			.then(res => res.json())
			.catch(this.handleError);
	}
	getAccountDetail(data: Object) {
		return this.http
			.post(this.account_detail, data)
			.toPromise()
			.then(res => res.json())
			.catch(this.handleError);
	}
	resetPassword(data: Object) {
		return this.http
			.post(this.reset_password, data)
			.toPromise()
			.then(res => res.json())
			.catch(this.handleError);
	}

	private handleError(error: any): Promise<any> {
		console.error('An error occurred', error); // for demo purposes only
		return Promise.reject(error.message || error);
	}

}



// WEBPACK FOOTER //
// ./src/app/profile/profile.service.ts